import type { ListingOwnerGoodFor, PlaceGoodForOccasion } from '@pulsify/shared/dto'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { listingGoodForApi } from '~/entities/listing-good-for/api/listing-good-for-api'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { MINUTES } from '~/shared/lib/time-constants'

export function useListingGoodFor(businessId: string, listingId: string) {
  return useQuery({
    queryKey: queryKey(QueryKey.LISTING_GOOD_FOR, listingId),
    queryFn: () => listingGoodForApi.get(businessId, listingId),
    staleTime: MINUTES,
    enabled: !!businessId && !!listingId,
  })
}

/** Saves the place's own occasions at once and shows them before the server answers. */
export function useUpdateListingGoodFor(businessId: string, listingId: string) {
  const queryClient = useQueryClient()
  const key = queryKey(QueryKey.LISTING_GOOD_FOR, listingId)
  return useMutation({
    mutationFn: (chosen: PlaceGoodForOccasion[]) =>
      listingGoodForApi.update(businessId, listingId, { chosen }),
    onMutate: async (chosen) => {
      await queryClient.cancelQueries({ queryKey: key })
      const previous = queryClient.getQueryData<ListingOwnerGoodFor>(key)
      if (previous) queryClient.setQueryData<ListingOwnerGoodFor>(key, { ...previous, chosen })
      return { previous }
    },
    onError: (_error, _chosen, context) => {
      if (context?.previous) queryClient.setQueryData(key, context.previous)
    },
    onSuccess: (state) => queryClient.setQueryData(key, state),
  })
}
